//console.log("Running in mode: " + process.env.REACT_APP_MODE);

const dev = {
  services: {
    api_tv: {
      url: "https://www.tdtchannels.com/lists/tv",
      epg: "https://www.tdtchannels.com/epg/TV.json",
    },
    api_radio: {
      url: "https://www.tdtchannels.com/lists/radio",
      epg: "https://www.tdtchannels.com/epg/RADIO.json",
    },
  },
};

const prod = {
  services: {
    api_tv: {
      url: "https://www.tdtchannels.com/lists/tv",
      epg: "https://www.tdtchannels.com/epg/TV.json",
    },
    api_radio: {
      url: "https://www.tdtchannels.com/lists/radio",
      epg: "https://www.tdtchannels.com/epg/RADIO.json",
    },
  },
};

const config = process.env.REACT_APP_MODE === "production" ? prod : dev;

export default config;
